/*
 * View for the topic label modal
 */

define(["marionette", "messaging/messenger", "./template/basicKbRoleInfoTemplate.html"], function (
  Marionette,
  Messenger,
  BasicKbRoleInfoTemplate,
) {
  var BasicKbRoleInfoView = {};

  BasicKbRoleInfoView.basicKbRoleInfoView = Marionette.ItemView.extend({
    className: "row-fluid",
    template: BasicKbRoleInfoTemplate,
    showError: function (div, errorMessage) {
      this.$el
        .find(div)
        .html('<h5 class="error-message">' + errorMessage + "</h5>")
        .hide()
        .fadeIn();
    },
    textboxes: {
      "#name": {
        enableSelector: ["#nameLabel", "#name"],
        modelAttribute: "name",
        placeholder: "admin.kbRoleAdmin.name",
        textArea: false,
      },
      "#description": {
        enableSelector: ["#descriptionLabel", "#description"],
        modelAttribute: "description",
        placeholder: "admin.kbRoleAdmin.description",
        textArea: false,
      },
    },
    events: {
      //This will handle changing which KB is selected.  We use JQuery to figure out the ID of the KB
      //whose drop-down entry was selected
      "change #kbId": function () {
        var kbId = parseInt(this.$el.find("#kbId option:selected").val(), 10);
        this.trigger("kbRole:kbId:changed", kbId);
      },
      "click #btnShowHistory": function (e) {
        // Cancel any possible navigation
        e.preventDefault();
        e.stopPropagation();
        this.trigger("click:show:history");
      },
    },
    templateHelpers: {
      getDateDisplay: function (date) {
        return Messenger.reqres.request("get:formatted:date:long", date);
      },
    },
  });

  return BasicKbRoleInfoView;
});
